"use strict";

export default function () {
    document.addEventListener("DOMContentLoaded", function () {
        const root = document.querySelector(".o-vantagens-categorias");
        if (!root) return;

        // evitar múltiplas execuções
        if (root.dataset.vantagensInit === "1") return;
        root.dataset.vantagensInit = "1";

        const slider = root.querySelector(".o-vantagens-categorias__menus");
        const btnLeft = root.querySelector(".arrow-left");
        const btnRight = root.querySelector(".arrow-right");

        if (!slider) return;

        const buttons = [
            ...root.querySelectorAll(".o-vantagens__button-categoria"),
        ];
        const panels = [
            ...root.querySelectorAll(".o-vantagens-categorias__item"),
        ];
        if (!buttons.length || buttons.length !== panels.length) return;

        /* ===========================================================
       TROCA DE CONTEÚDO
    =========================================================== */
        function activate(i) {
            buttons.forEach((b, idx) =>
                b.classList.toggle("active", idx === i)
            );
            panels.forEach(
                (p, idx) => (p.style.display = idx === i ? "" : "none")
            );
        }
        activate(0);

        /* ===========================================================
       DRAG SEM DELAY / SEM SALTOS
    =========================================================== */
        let isDown = false;
        let startX = 0;
        let scrollStart = 0;
        let moved = false;

        slider.style.userSelect = "none";

        slider.addEventListener("mousedown", (e) => {
            isDown = true;
            moved = false;
            startX = e.pageX;
            scrollStart = slider.scrollLeft;

            slider.classList.add("is-grabbing");
            e.preventDefault();
        });

        document.addEventListener("mousemove", (e) => {
            if (!isDown) return;

            const delta = e.pageX - startX;
            if (Math.abs(delta) > 2) moved = true;

            slider.scrollLeft = scrollStart - delta;
            updateArrows();
            e.preventDefault();
        });

        document.addEventListener("mouseup", (e) => {
            if (isDown) {
                slider.classList.remove("is-grabbing");

                if (!moved) {
                    const btn = e.target.closest(
                        ".o-vantagens__button-categoria"
                    );
                    if (btn) {
                        const index = buttons.indexOf(btn);
                        if (index !== -1) activate(index);
                    }
                }
            }
            isDown = false;
        });

        slider.addEventListener("pointerleave", () => {
            slider.classList.remove("is-grabbing");
            isDown = false;
        });

        /* ===========================================================
       ARROWS — SCROLL SUAVE + ESTADOS ATIVO / INATIVO
    =========================================================== */

        function getScrollAmount() {
            const first = buttons[0];
            if (!first) return 120;
            return first.offsetWidth + 12;
        }

        function updateArrows() {
            const maxScroll = slider.scrollWidth - slider.clientWidth;

            if (!btnLeft || !btnRight) return;

            // está no início
            if (slider.scrollLeft <= 5) {
                btnLeft.classList.add("disabled");
            } else {
                btnLeft.classList.remove("disabled");
            }

            // está no final
            if (slider.scrollLeft >= maxScroll - 5) {
                btnRight.classList.add("disabled");
            } else {
                btnRight.classList.remove("disabled");
            }
        }

        if (btnLeft) {
            btnLeft.addEventListener("click", () => {
                if (btnLeft.classList.contains("disabled")) return;

                slider.scrollBy({
                    left: -getScrollAmount(),
                    behavior: "smooth",
                });

                setTimeout(updateArrows, 250);
            });
        }

        if (btnRight) {
            btnRight.addEventListener("click", () => {
                if (btnRight.classList.contains("disabled")) return;

                slider.scrollBy({
                    left: getScrollAmount(),
                    behavior: "smooth",
                });

                setTimeout(updateArrows, 250);
            });
        }

        // Atualiza ao carregar
        updateArrows();

        // Atualiza também no scroll (touch/drag)
        slider.addEventListener("scroll", updateArrows);
    });
}
